export default "__VITE_ASSET__BhIUpLJF__"